import { render, staticRenderFns } from "./ExamAttributeTypeNumeric.vue?vue&type=template&id=2a70785e&scoped=true&"
import script from "./ExamAttributeTypeNumeric.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeTypeNumeric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70785e",
  null
  
)

export default component.exports